// Central data and image references for KTS-Entreprise A/S

export const SITE_INFO = {
  companyName: "KTS-Entreprise A/S",
  tagline: "Entreprenør og autoriseret kloakmester",
  cvr: "16682144",
  address: "Industrivej 3, 3300 Frederiksværk",
  phone: "47 77 25 77",
  mainPhone: "47 77 25 77",
  email: "mail@kts-entreprise.dk",
  fakturaEmail: "faktura@kts-entreprise.dk",
  openingHours: {
    monThu: "6.30–15.30",
    fri: "6.30–15.00",
    display: "Mandag–torsdag: 6.30–15.30 | Fredag: 6.30–15.00"
  },
  contacts: [
    {
      role: "Direktør",
      category: "Ledelse og administration",
      name: "Anette Nielsen",
      phone: "40 85 70 70",
      email: "Anette@kts-entreprise.dk",
      image: "https://assets.auxodev.dk/assets/e25852aa-8434-4aa0-ac76-be91340b9170/anette-nielsen-direktor.jpg"
    },
    {
      role: "Daglig leder",
      category: "Ledelse og administration",
      name: "Torben Køster Sørensen",
      phone: "40 32 77 13",
      email: "torben@kts-entreprise.dk",
      image: "https://assets.auxodev.dk/assets/e25852aa-8434-4aa0-ac76-be91340b9170/torben-koester-soerensen-daglig-leder.jpg"
    },
    {
      role: "Administration og markedsføring",
      category: "Ledelse og administration",
      name: "Susanne Stenfors",
      phone: "26 30 25 77",
      email: "sanne@kts-entreprise.dk",
      image: "https://assets.auxodev.dk/assets/e25852aa-8434-4aa0-ac76-be91340b9170/susanne-stenfors-kontor.jpg"
    },
    {
      role: "Autoriseret kloakmester",
      category: "Kloak og TV-inspektion",
      name: "Lukas Corneliussen",
      phone: "51 93 21 41",
      email: "Lukas@kts-entreprise.dk",
      image: "https://assets.auxodev.dk/assets/e25852aa-8434-4aa0-ac76-be91340b9170/lukas-corneliussen-kloakmester.jpg"
    },
    {
      role: "TV-inspektion",
      category: "Kloak og TV-inspektion",
      name: "Kim Hougaard Jensen",
      phone: "23 65 25 77",
      email: "Kim@kts-entreprise.dk",
      image: "https://assets.auxodev.dk/assets/e25852aa-8434-4aa0-ac76-be91340b9170/kim-hougaard-jensen-tv-inspektion.jpg"
    },
    {
      role: "Værksted og mekaniker",
      category: "Værksted",
      name: "Peter Corneliussen",
      phone: "26 30 25 76",
      email: "pco@kts-entreprise.dk",
      image: "https://assets.auxodev.dk/assets/e25852aa-8434-4aa0-ac76-be91340b9170/peter-corneliussen-mekaniker.jpg"
    }
  ]
};

export const BRAND_ASSETS = {
  logo: "https://assets.auxodev.dk/assets/e25852aa-8434-4aa0-ac76-be91340b9170/imgi-8-slide1-edited.jpg",
  diBadge: "https://assets.auxodev.dk/assets/e25852aa-8434-4aa0-ac76-be91340b9170/medlem-af-di-dansk-byggeri-rgb-edited.png",
  diBadgeLarge: "https://assets.auxodev.dk/assets/e25852aa-8434-4aa0-ac76-be91340b9170/medlem-af-di-dansk-byggeri-rgb.png",
  diLink: "https://dit.di.dk/Company/1161907/memberships/confirm/4",
  bygGarantiConditionsLink: "https://www.byggaranti.dk/forbrugere/hvad-daekker-garantien/",
  heroSlide: "https://assets.auxodev.dk/assets/e25852aa-8434-4aa0-ac76-be91340b9170/slide1-edited.jpg",
  heroSlideWide: "https://assets.auxodev.dk/assets/e25852aa-8434-4aa0-ac76-be91340b9170/slide1-edited_2e4c64e8.jpg",
  excavatorHero: "https://assets.auxodev.dk/assets/e25852aa-8434-4aa0-ac76-be91340b9170/dsc4768b-edited.jpg",
  truckJob: "https://assets.auxodev.dk/assets/e25852aa-8434-4aa0-ac76-be91340b9170/dsc4803b.jpg",
  badge500: "https://assets.auxodev.dk/assets/e25852aa-8434-4aa0-ac76-be91340b9170/500x245-s-lv-5-dk-003.png",
  defaultOgImage: "https://assets.auxodev.dk/assets/e25852aa-8434-4aa0-ac76-be91340b9170/7b4765-af6d0c462f414287a07066f34fda9d4b.jpg"
};

// Featured projects for the homepage and project index
export const FEATURED_PROJECTS = [
  {
    id: "smk",
    title: "Spejlbassin ved Statens Museum for Kunst",
    category: "Betonarbejde",
    description: "Cirkulært spejlbassin på 700 m² med 80 tons armeringsjern og specialfremstillede Gote-kantelementer foran SMK i København.",
    href: "/smk",
    image: "https://assets.auxodev.dk/assets/e25852aa-8434-4aa0-ac76-be91340b9170/statens-museum-13.jpg"
  },
  {
    id: "belaegning",
    title: "Entreprenør- og belægningsarbejde",
    category: "Entreprenør og anlæg",
    description: "Udførelse af præcisionsarbejde med belægning, trapper, haveanlæg og terrænregulering for private og erhverv.",
    href: "/entreprenerservice",
    image: "https://assets.auxodev.dk/assets/e25852aa-8434-4aa0-ac76-be91340b9170/indkoersel-med-fliser-2.jpg"
  },
  {
    id: "kloak-tv",
    title: "Kloak- og TV-inspektion i Nordsjælland",
    category: "Kloak og klimasikring",
    description: "Autoriseret undersøgelse af kloakledninger, spuling, lokalisering af skader samt udførelse af faskiner og højvandslukkere.",
    href: "/tv-inspektion",
    image: "https://assets.auxodev.dk/assets/e25852aa-8434-4aa0-ac76-be91340b9170/3152.jpg"
  }
];

// Initial static fallback data matching CMS items
export const INITIAL_GALLERIES = [
  {
    gallery_key: "entreprenerservice",
    title: "Entreprenør og anlæg Galleri",
    description: "Billeder fra entreprenørarbejde, belægning og anlægsprojekter",
    images: [
      "https://assets.auxodev.dk/assets/e25852aa-8434-4aa0-ac76-be91340b9170/7b4765-09ef0efeb57c490197d2f9bee7e5ca2a-mv2.jpg",
      "https://assets.auxodev.dk/assets/e25852aa-8434-4aa0-ac76-be91340b9170/7b4765-d38e0f9b68f84b0498ae8ac9079de350-mv2-d-2592-1944-s-2.jpg",
      "https://assets.auxodev.dk/assets/e25852aa-8434-4aa0-ac76-be91340b9170/7b4765-a9e4141e9c59baedef843dd05dadf2b7.jpg"
    ]
  },
  {
    gallery_key: "tv-inspektion",
    title: "TV-inspektion og kloakspuling Galleri",
    description: "Kameraføring, lokalisering af skader, rørbrud og kloakspuling",
    images: [
      "https://assets.auxodev.dk/assets/e25852aa-8434-4aa0-ac76-be91340b9170/tv-inspektion-udstyr.webp",
      "https://assets.auxodev.dk/assets/e25852aa-8434-4aa0-ac76-be91340b9170/tv-inspektion-kloakledning.webp",
      "https://assets.auxodev.dk/assets/e25852aa-8434-4aa0-ac76-be91340b9170/tv-inspektionsbil.webp",
      "https://assets.auxodev.dk/assets/e25852aa-8434-4aa0-ac76-be91340b9170/7b4765-1f3b6823636942d09b709186c4d005b4-mv2-d-4160-3120-s-4-2.jpg",
      "https://assets.auxodev.dk/assets/e25852aa-8434-4aa0-ac76-be91340b9170/7b4765-db3906a3debf453f825dfef4dad4494b-mv2-d-4160-3120-s-4-2.jpg",
      "https://assets.auxodev.dk/assets/e25852aa-8434-4aa0-ac76-be91340b9170/7b4765-c913ff5fb7b043198f172761c8368fbc-mv2-d-4160-3120-s-4-2_fadf8726.jpg",
      "https://assets.auxodev.dk/assets/e25852aa-8434-4aa0-ac76-be91340b9170/7b4765-f17717104ffe4b989286cba5f99e5b48-mv2-d-4160-3120-s-4-2.jpg"
    ]
  },
  {
    gallery_key: "betonarbejde",
    title: "Betonarbejde Galleri",
    description: "Fundamenter, støbemure, elevatorskakte, dæk og reparationer",
    images: [
      "https://assets.auxodev.dk/assets/e25852aa-8434-4aa0-ac76-be91340b9170/7b4765-b6872615534a47e3bb500a1c00dd386b.jpg",
      "https://assets.auxodev.dk/assets/e25852aa-8434-4aa0-ac76-be91340b9170/7b4765-d38e0f9b68f84b0498ae8ac9079de350-mv2-d-2592-1944-s-2_1076090b.jpg",
      "https://assets.auxodev.dk/assets/e25852aa-8434-4aa0-ac76-be91340b9170/7b4765-9ad44a1423d64ddcad691372bf5c9613-mv2-d-3968-2976-s-4-2.jpg",
      "https://assets.auxodev.dk/assets/e25852aa-8434-4aa0-ac76-be91340b9170/7b4765-770c7020ec3c4c119ac3f41127eef090.jpg",
      "https://assets.auxodev.dk/assets/e25852aa-8434-4aa0-ac76-be91340b9170/7b4765-0848bb69fe18473d985ac4f08108c1d2_594afdc1.jpg",
      "https://assets.auxodev.dk/assets/e25852aa-8434-4aa0-ac76-be91340b9170/7b4765-c175b7692b5242baa0d4a5a1fa429c1e_a2c4ec81.jpg",
      "https://assets.auxodev.dk/assets/e25852aa-8434-4aa0-ac76-be91340b9170/7b4765-d592b4ffa2db4e4193af8f792a88801d_2ef8d1d3.jpg",
      "https://assets.auxodev.dk/assets/e25852aa-8434-4aa0-ac76-be91340b9170/7b4765-7a4c02ac875f4bf396279abf45e738e5_665a5345.jpg",
      "https://assets.auxodev.dk/assets/e25852aa-8434-4aa0-ac76-be91340b9170/7b4765-44181573312bb00671ae85efd306b6d3.jpg",
      "https://assets.auxodev.dk/assets/e25852aa-8434-4aa0-ac76-be91340b9170/7b4765-789cc1c65d82ce9218373ad6274820b8.jpg",
      "https://assets.auxodev.dk/assets/e25852aa-8434-4aa0-ac76-be91340b9170/7b4765-b1fdca659d549575dbd6f45c96765e83.jpg",
      "https://assets.auxodev.dk/assets/e25852aa-8434-4aa0-ac76-be91340b9170/7b4765-10c66bd12911c085a5140ae9f4f112fb.jpg",
      "https://assets.auxodev.dk/assets/e25852aa-8434-4aa0-ac76-be91340b9170/7b4765-bd3c822063b7aa8590133cd9e384bb21.jpg",
      "https://assets.auxodev.dk/assets/e25852aa-8434-4aa0-ac76-be91340b9170/7b4765-9808255c83f6484ec8488118b3e7be6e.jpg",
      "https://assets.auxodev.dk/assets/e25852aa-8434-4aa0-ac76-be91340b9170/7b4765-2846d39546f3eef3d5ad7150977794dd.jpg",
      "https://assets.auxodev.dk/assets/e25852aa-8434-4aa0-ac76-be91340b9170/7b4765-2ec8779831e6b54efb7261eae7bf1720.jpg",
      "https://assets.auxodev.dk/assets/e25852aa-8434-4aa0-ac76-be91340b9170/7b4765-aed6252641f086345e2f8321a171a1cf.jpg"
    ]
  },
  {
    gallery_key: "smk",
    title: "Statens Museum for Kunst Galleri",
    description: "Betonstøbning af spejlbassin, Gote betonsten og armering",
    images: [
      "https://assets.auxodev.dk/assets/e25852aa-8434-4aa0-ac76-be91340b9170/7b4765-1b4c6241ec664637ac0a224cf8780a9f.png",
      "https://assets.auxodev.dk/assets/e25852aa-8434-4aa0-ac76-be91340b9170/7b4765-1857bd1e4d5b492f897455c875a655c1.jpg",
      "https://assets.auxodev.dk/assets/e25852aa-8434-4aa0-ac76-be91340b9170/7b4765-2db2d7f196a24afc9b3edea558a4b5a0.jpg",
      "https://assets.auxodev.dk/assets/e25852aa-8434-4aa0-ac76-be91340b9170/7b4765-7f3fa79ab7d8449c9b17a29cf4b0aefa.jpg",
      "https://assets.auxodev.dk/assets/e25852aa-8434-4aa0-ac76-be91340b9170/7b4765-7a4c02ac875f4bf396279abf45e738e5.jpg",
      "https://assets.auxodev.dk/assets/e25852aa-8434-4aa0-ac76-be91340b9170/7b4765-a772a13612f84660bc115bc3e442bca0.jpg",
      "https://assets.auxodev.dk/assets/e25852aa-8434-4aa0-ac76-be91340b9170/7b4765-27299c86d9924e01a8056b828cf01172.jpg",
      "https://assets.auxodev.dk/assets/e25852aa-8434-4aa0-ac76-be91340b9170/7b4765-bfdc1a13a72244dcb10912d69443865e.jpg",
      "https://assets.auxodev.dk/assets/e25852aa-8434-4aa0-ac76-be91340b9170/7b4765-361f34b5a4d341d4a6621a6f31b0ce5c.jpg",
      "https://assets.auxodev.dk/assets/e25852aa-8434-4aa0-ac76-be91340b9170/7b4765-f108959e9e4849c69c22af14247c08de.jpg"
    ]
  },
  {
    gallery_key: "bygningsaffald",
    title: "På pladsen – Materialer Galleri",
    description: "Genbrugsmaterialer, grus, bakkestabil, ærtesten og støbemix på pladsen",
    images: [
      "https://assets.auxodev.dk/assets/e25852aa-8434-4aa0-ac76-be91340b9170/materialer-muldjord.webp",
      "https://assets.auxodev.dk/assets/e25852aa-8434-4aa0-ac76-be91340b9170/7b4765-656dae92f2b047efa43f7b027ef35103-mv2.jpg",
      "https://assets.auxodev.dk/assets/e25852aa-8434-4aa0-ac76-be91340b9170/7b4765-48c37dfe95354e53b4fb866a4b638ba4-mv2.jpg",
      "https://assets.auxodev.dk/assets/e25852aa-8434-4aa0-ac76-be91340b9170/7b4765-fe5531b891774e079ccb03a23ccc8e88-mv2.jpg",
      "https://assets.auxodev.dk/assets/e25852aa-8434-4aa0-ac76-be91340b9170/7b4765-2dd56f471619451fb04734b0a7181447-mv2.jpg",
      "https://assets.auxodev.dk/assets/e25852aa-8434-4aa0-ac76-be91340b9170/7b4765-ae4c5fafe05b43fa8d8902d7a7273843-mv2.jpg",
      "https://assets.auxodev.dk/assets/e25852aa-8434-4aa0-ac76-be91340b9170/7b4765-54ccfafb524d4d989641844332a7abb6-mv2_cafd3021.jpg",
      "https://assets.auxodev.dk/assets/e25852aa-8434-4aa0-ac76-be91340b9170/7b4765-3b205ce5f2304e58bd14b53f5b9caf84-mv2.jpg"
    ]
  }
];
